import { createContext } from "react";

const LoadWalletContext = createContext();

export default LoadWalletContext;
